import { PostMessageOptions } from "."

export function handleOpenOffersModule({ props, data }: PostMessageOptions) {
    const { history } = props
    const { openOffersModule } = data

    if (openOffersModule) {
        const workTaskId = props.getCurrentOrNewWorkTaskId()
        history.push(`/${workTaskId}/offers`)
    }
}
